const StackingCards = function (gsap, ScrollTrigger) {
    let spacer = 50;
    const minScale = 0.8;
    const distributor = gsap.utils.distribute({ base: minScale, amount: 0.2 });
    let mm = gsap.matchMedia();


    // get all stacking card sections
    const stackingCardSections = document.querySelectorAll('.section-stacking-cards');

    stackingCardSections.forEach((stackingCardSection) => {

        // get all cards within the section
        const cards = stackingCardSection.querySelectorAll('.card');
        cards.forEach((card, i) => {
            cardArr = gsap.utils.toArray(card);
            const scaleVal = distributor(i, cards[i], cards);

            mm.add("(min-width: 800px)", () => {
                // desktop
                const tween = gsap.to(card, {
                    scrollTrigger: {
                        trigger: card,
                        start: `top top`,
                        scrub: true,
                        // markers: true,
                        invalidateOnRefresh: true
                    },
                    ease: "none",
                    scale: scaleVal
                });

                ScrollTrigger.create({
                    trigger: cardArr,
                    start: `top-=${i * spacer} 15%`,
                    endTrigger: '.section-stacking-cards',
                    end: `bottom top+=${card.offsetHeight + (cards.length * spacer)}`,
                    pin: true,
                    pinSpacing: false,
                    // markers: true,
                    id: `pin${i}Desktop`,
                    invalidateOnRefresh: true,
                });
            });

            mm.add("(max-width: 799px)", () => {
                spacer = 30;
                const tween = gsap.to(card, {
                    scrollTrigger: {
                        trigger: card,
                        start: `-100 top`,
                        scrub: true,
                        // markers: true,
                        invalidateOnRefresh: true
                    },
                    ease: "none",
                    scale: scaleVal
                });

                ScrollTrigger.create({
                    trigger: card,
                    start: `top-=${i * spacer} 12%`,
                    endTrigger: '.section-stacking-cards',
                    end: `bottom top+=${650 + (cards.length * spacer)}`,
                    pin: true,
                    pinSpacing: false,
                    // markers: true,
                    id: 'pin',
                    invalidateOnRefresh: true,
                });
            });
        });
    });
}

export default StackingCards;
